import React from "react";
import "../../Styles/cdm.css";
import { ToastContainer } from "react-toastify";
import PageHeading from "../PageHeading";
import Constituency from "./Constituency";
import Parliamentary from "./Parliamentary/Parliamentary";
import useConstituencyData from "./hooks/useConstituencyData";
import { useTranslation } from "react-i18next";


const Result = () => {
  const { t } = useTranslation();

  const { constituencyData, loading } = useConstituencyData(1);
  return (
    <>
      <div className='constituency-section'>
        <ToastContainer />
        <div className="ml-4">
          <PageHeading className={`ml-50`} pageTitle={t("constituencyDataManagement")} />
        </div>
        {constituencyData?.type === 'state' && <Constituency constituencyData={constituencyData} loading={loading} />}
        {constituencyData?.type === 'central' && <Parliamentary constituencyData={constituencyData} loading={loading} />}
      </div>
    </>
  );
};

export default Result;
